<template>
 <div class="as-container as-container--border">
    <div class="as-box">
      <div class="as-body">
        <category class="category" :categories="ages" :heading="$t('message.categoryWidgets.ageGroups')"/>
      </div>
    </div>
    <div class="as-box">
      <div class="as-body">
        <category class="category" :categories="revenus" :heading="$t('message.categoryWidgets.incomeGroups')"/>
      </div>
    </div>
  </div>
</template>

<script>

import Category from './Category.vue'

export default {
  name: 'Customers',
  components: {
    Category
  },
  data () {
    return {
    }
  },
  computed: {
    ages () {
      return this.$store.getters['ages'](this.$t('message.categoryWidgets.ageVariables'))
    },
    revenus () {
      return this.$store.getters['revenuesCategories'](this.$t('message.categoryWidgets.revenuVariables'))
    }
  }
}
</script>
<style>

</style>
